import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useSaveVaccine = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (vaccineData) => {
      const axiosInstance = createAxiosInstance();
      return axiosInstance.post(`${tenantVal}/immunisation`, vaccineData);
    },
    onSuccess: (_, vaccineData) => {
      toast.success(vaccineData.id ? "Vaccine updated successfully" : "Vaccine added successfully");
      queryClient.invalidateQueries({ queryKey: ["settingsVaccines", tenantVal] });
    },
    onError: (error) => {
      toast.error(error.message || "An error occurred");
    },
  });
};
